










import { Component, Vue, Prop } from 'vue-property-decorator'
import { Game } from '@/class/game'
import { GamePlayer } from '@/class/gamePlayer'
import { RoleId } from '@/enum'
import SimpleModal from '@/components/Utils/modal/SimpleModal.vue'
import RoleList from './RoleList.vue'

@Component({
  components: {
    SimpleModal,
    RoleList
  }
})
export default class SelfProclaimNoticeModal extends Vue {
  @Prop() game!: Game;
  @Prop() player!: GamePlayer;

  proclaimRoleNotice (roleId: RoleId) {
    this.game.proclaimRoleNotice(this.player.id, roleId)
  }
}
